export const setTemporaryTransition = (element, transition = 200) => {
  element.style.transition = `${transition / 1000}s ease`;

  setTimeout(() => {
    element.style.transition = null;
  }, transition);
};
